// extracted by mini-css-extract-plugin
export var playBtn = "VimeoPlayButton-module--play-btn--3c362";